
import { css } from 'lit';
export default css`
pc-person-card{
  position:relative;
}

pc-person-card pc-heading{
  --heading-line-height:var(--lh-h4);
}

pc-person-card pc-heading a{
    transition:all 300ms;
    font-weight:var(--fw-medium);
  }

pc-person-card pc-heading a pc-icon{
      margin-left:var(--spacing-1);
      display:inline;
      opacity:0;
      transition:all 300ms;
    }

pc-person-card pc-heading a:focus,
  pc-person-card pc-heading a:hover{
    color:var(--purple-indigo);
  }

pc-person-card pc-heading a:focus pc-icon, pc-person-card pc-heading a:hover pc-icon{
      opacity:1;
      color:var(--purple-indigo);
    }

pc-person-card pc-heading a:after{
    position:absolute;
    inset:0;
    content:'';
  }
`;